import { Component, Input } from '@angular/core';
import { EChartsOption } from 'echarts';
import { IRiskGraph, IRiskQuestions } from 'src/app/models/riskProfile';
import * as echarts from 'echarts';

@Component({
  selector: 'app-risk-line-graph',
  templateUrl: './risk-line-graph.component.html',
  styleUrl: './risk-line-graph.component.scss',
})
export class RiskLineGraphComponent {
  @Input() set chartHeight(val: any) {
    if (val) this.height = val + 'px';
  }
  @Input() set riskQuestionsTotal(val: IRiskQuestions[]) {
    if (val.length > 0) {
      this.getBaseLine(val);
    }
  }
  @Input() set rishGraphDetails(val: IRiskGraph[]) {
    if (val.length > 0) {
      this.rishGraphData = val;
      this.setChartData(val);
    }
  }
  @Input() set riskGraphData(val: RiskProfileGraph) {
    if (
      val &&
      val.riskCurrent &&
      val.riskPrevious &&
      val.riskPrevious != null &&
      val.riskCurrent != null
    ) {
      if (val.riskCurrent.length > 0 && val.riskPrevious.length == 0) {
        this.getBaseLine(val.riskQuestions);
        this.setChartData(val.riskCurrent);
      } else if (val.riskCurrent.length == 0 && val.riskPrevious.length > 0) {
        this.getBaseLine(val.riskQuestions);
        this.setChartData(val.riskPrevious);
      } else if (val.riskCurrent.length > 0 && val.riskPrevious.length > 0) {
        this.getBaseLinePrevious(val.riskPrevious);
        this.setChartData(val.riskCurrent);
      }
      // this.rishGraphData = val;
      // this.setChartData(val);
    }
  }

  height = '';
  rishQuestionsTotal: number = 0;
  rishGraphData: IRiskGraph[];
  chartOption: EChartsOption;
  getBaseLinePrevious(val: IRiskGraph[]) {
    let total = 0;
    val.forEach((risk) => {
      total += risk.riskTotalScores;
    });
    this.rishQuestionsTotal = total;
  }
  getBaseLine(val: IRiskQuestions[]) {
    let total = 0;
    val.forEach((question) => {
      total += parseFloat(question.riskTotal);
    });
    this.rishQuestionsTotal = total;
  }
  private setChartData(val: IRiskGraph[]): void {
    const copiedDatesArray = val.slice();
    const sortedDate = copiedDatesArray.sort(
      (a, b) =>
        new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime()
    );

    const dates = sortedDate.map((item) =>
      new Date(item.eventDate).toLocaleString('en-US')
    );

    const latestScores = sortedDate.map((item) => item.riskTotalScores);
    const previousScores = sortedDate.map((item) => this.rishQuestionsTotal);
    const combinedArray = [...latestScores, ...previousScores];
    const maxVal = Math.max(...combinedArray);

    this.chartOption = {
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: ['Risk Before', 'Risk After'],
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '12%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: dates,
        axisLabel: {
          rotate: dates.length > 8 ? 45 : 0,
          formatter: (value: string) => {
            const date = new Date(value);
            const month = date.toLocaleString('en-us', { month: 'short' });
            const day = date.getDate();
            return `${month} ${day}`;
          },
        },
      },
      yAxis: {
        type: 'value',
        min: 0,
        max: maxVal + 10,
      },
      series: [
        {
          name: 'Risk Before',
          type: 'line',
          stack: 'intrusion',
          data: previousScores,
        },
        {
          name: 'Risk After',
          type: 'line',
          stack: 'face',
          data: latestScores,
        },
      ],
      dataZoom: [
        {
          type: 'slider',
          show: true,
          xAxisIndex: [0],
          start: 0, // Start position of the slider (0% of the data)
          end: 100, // End position of the slider (100% of the data)
        },
        {
          type: 'inside',
          xAxisIndex: [0],
          start: 0,
          end: 100,
        },
      ],
    } as EChartsOption;

    // Set up chart instance
    const chartInstance = echarts.init(
      document.getElementById('chartRisk') as HTMLElement
    );
    chartInstance.setOption(this.chartOption);

    // Add event listener for data zoom
    chartInstance.on('datazoom', (params: any) => {
      const start = params.start / 100;
      const end = params.end / 100;
      const startIndex = Math.floor(start * dates.length);
      const endIndex = Math.floor(end * dates.length);

      const visibleLatestScores = latestScores.slice(startIndex, endIndex + 1);
      const visiblePreviousScores = previousScores.slice(
        startIndex,
        endIndex + 1
      );
      const visibleCombinedArray = [
        ...visibleLatestScores,
        ...visiblePreviousScores,
      ];
      const newMaxVal = Math.max(...visibleCombinedArray);
      // Update the yAxis max value dynamically
      chartInstance.setOption({
        yAxis: {
          max: newMaxVal + 10,
        },
      });
    });
  }
}
export interface RiskProfileGraph {
  riskQuestions: IRiskQuestions[];
  riskCurrent: IRiskGraph[];
  riskPrevious: IRiskGraph[];
}
